import { defineStore } from 'pinia';
import { BellNotificationData } from '@/js/store/notifications/types/types';
import { fetchBellNotificationData } from '@/js/store/notifications/services/api';

interface BellNotificationDataStore {
    bellNotificationData: BellNotificationData | null;
    loading: boolean;
}
export const useBellNotificationDataStore = defineStore({
    id: 'bellNotificationData',
    state: (): BellNotificationDataStore => ({
        bellNotificationData: null,
        loading: false,
    }),
    actions: {
        async getBellNotificationData() {
            this.loading = true;

            try {
                this.bellNotificationData = await fetchBellNotificationData();
                this.loading = false;
            } catch (error) {
                this.loading = true;
                // eslint-disable-next-line no-console
                console.error('Error fetching bell notification data:', error);
            }
        },
    },
});
